import { HostingService } from '../../services/hosting_service';
import { MicroRoutes } from '../../services/micro_routes';

interface IWindowSGDDesktop extends Window {
  hiReady: (callback: () => void) => void;
  $ip: {
    require<M>(s: string): Promise<M>;
    requires<M>(s: string[]): Promise<M[]>;
  };
}

declare var window: IWindowSGDDesktop;

export class NavHostController {
  constructor(public ngMicroRoutes: typeof MicroRoutes, public ngHostingService: HostingService) {}
}

export const NavHostDirective = {
  restrict: 'E',
  replace: false,
  // we want to pollute the scope to save the micro and shut it down on element.destroy
  //
  scope: true,
  controller: 'NavHostController',
  link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: unknown, controller: NavHostController) {
    const hostMicroEl = element[0];
    const { ngMicroRoutes, ngHostingService } = controller;
    // hosting service does not shutdown when we clear browser cache and hard refresh the app, which causing the api calls to fails because of missing authorization token
    if(ngHostingService.hostMicro) {
      ngHostingService.hostMicro.shutdown();
    }

    ngHostingService.defineGlobalConstants();
    ngHostingService.initializeMicro(hostMicroEl, ngMicroRoutes).then(() => {
      scope.hostMicro = ngHostingService.hostMicro;
      scope.hostListener = ngHostingService.hostListener;
    });

    scope.$on('$destroy', () => {
      scope.hostMicro.ess.off(scope.hostListener);
      scope.hostMicro.shutdown();
    });
  }
};



// WEBPACK FOOTER //
// ./app/lib/host/components/nav-host/nav-host.ts